
export class ProviderAdminObjectHistorySummaryModel {
  id: string;
  providerAdminObjectId: string;
  modificationDate: Date;
}
